import { render, staticRenderFns } from "./PRINT.vue?vue&type=template&id=60c38819&scoped=true&"
import script from "./PRINT.vue?vue&type=script&lang=js&"
export * from "./PRINT.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c38819",
  null
  
)

export default component.exports